<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="pd-025 mt-20" >
            <div class="product-list bg-fff">
                <div class="product-item" v-for="(prod,prodIndex) in entity.productList" :key="prodIndex">
                    <div class="flex pd-250">
                        <div class="product-img"><img :src="prod.imgPathView" alt=""></div>
                        <div class="product-info flex1 ofh">
                            <div class="fs-28 color-000 name">{{prod.productName}}</div>
                            <div class="mt-15 fs-28 color-999">规格：{{prod.specName}}</div>
                            <div class="flex-between fs-28 color-999">
                                <div>销售价：¥{{prod.salePrice}}</div>
                                <div>x{{prod.productQty}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex pd-250 fs-28 bd-top" v-if="entity.orderMessage">
                    <div class="color-999">留言</div>
                    <div class="color-333 ml-20">{{entity.orderMessage}}</div>
                </div>
            </div>
        </div>
        <div class="card mt-20 mr-25 ml-25 pd-025">
            <div class="input-field bd-bot click" @click="showPop = true;">
                <div class="fs-32 color-333 left required">配送快递</div>
                <div class="field-content" :class="formItem.expressName ? 'color-333':'color-999'">{{formItem.expressName || '请选择配送快递'}}</div>
                <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
            </div>
            <div class="input-field" v-if="formItem.expressType !== 'ziying'">
                <div class="fs-32 color-333 left required">快递单号</div>
                <van-field class="input" type="text" :clearable="true" v-model="formItem.waybillNo" placeholder="请输入快递单号" />
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="send()">确认发货</div>
        </div>

        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="dicts['express_type']" value-key="codename"  @cancel="showPop = false" @confirm="onConfirm"  />
        </van-popup>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {getOrderDetail,sendOrder} from "@/api/order"
    import initDict from "@/mixins/initDict"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "sendOrder",
        components:{backTitleBar},
        mixins:[initDict,inputFix],
        data(){
            return {
                showPop:false,
                entity:{},
                formItem:{}
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'express_type',
            ]
            this.getThisDict(codeList)

            this.orderId = this.$route.query.orderId;
            this.getDetail();
        },
        watch: {
            'dicts.express_type'(list) {
                if (list && list.length && !this.formItem.expressType) {
                    this.initDefaultExpress();
                }
            }
        },
        methods:{
            getDetail(){
                getOrderDetail(this.orderId).then(res=>{
                    this.entity = res.data;
                })
            },
            initDefaultExpress() {
                const list = this.dicts['express_type'] || [];
                const ziying = list.find(item => item.code === 'ziying');
                if (ziying) {
                    this.$set(this.formItem, 'expressType', ziying.code);
                    this.$set(this.formItem, 'expressName', ziying.codename);
                }
            },
            onConfirm(value){
                this.$set(this.formItem,'expressType',value.code);
                this.$set(this.formItem,'expressName',value.codename);
                if (value.code === 'ziying') {
                    this.$set(this.formItem, 'waybillNo', '');
                }
                this.showPop = false;
            },
            send(){
                let form = this.formItem;
                if(!form.expressType){
                    this.$toast("请选择配送快递");
                    return
                }
                if(form.expressType !== 'ziying' && !form.waybillNo){
                    this.$toast("请填写快递单号");
                    return
                }
                let params = {
                    expressType: form.expressType,
                    expressName: form.expressName,
                    waybillNo: form.waybillNo,
                    orderId: this.entity.orderId,
                    orderStatus: 3
                }
                sendOrder(params).then(res => {
                    if (res.code === 0) {
                        this.$toast('发货成功');
                        this.$store.state.updateOrderList = true;
                        this.$router.back();
                    }
                }).finally(() => {

                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .product-list{
        padding: 0 .24rem;
        border-radius: .12rem;
    }
    .product-img{
        width: 1.7rem;
        height: 1.72rem;
        margin-right: .24rem;
    }
    .name{
        height: .8rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// sendOrder.vue?7be7d48b